<template>
    <CRow>
        <CCol col="12" lg="8" xl="6">
            <div :class="this.$func.storyblok2Css(blok)">
                <a v-if="blok.new_window" :href="blok.crosslink.url" target="_blank">{{blok.name}}</a>
                <a v-else :href="blok.crosslink.url" target="_self">{{blok.name}}</a>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    export default {
        props: ['blok']
    }
</script>